import {router} from 'redux-ui-router';
import {STATE_CHANGE_SUCCESS} from 'redux-ui-router/lib/action-types';

/**
 * @typedef {Object} RouterState
 * @property currentState
 * @property {?Object} currentParams
 * @property prevState
 * @property {?Object} prevParams
 * @property {Object<String, Boolean>} includes
 */

const initialState = {
  ...router(void 0, {}),
  includes: {},
};

export function routerReducer(state = initialState, action) {
  if (action.type === STATE_CHANGE_SUCCESS) {
    const nextState = router(state, action);

    if (nextState.currentState && nextState.currentState.name) {
      nextState.includes = calcIncludes(nextState.currentState.name);
    } else {
      nextState.includes = {};
    }

    return nextState;
  }

  return router(state, action);
}

function calcIncludes(name) {
  const tokens = name.split('.');

  let prev = tokens[0];
  const includes = {
    [prev]: true,
  };

  for (let i = 1, len = tokens.length; i < len; i++) {
    prev = `${prev}.${tokens[i]}`;
    includes[prev] = true;
  }

  return includes;
}

/**
 * @param {RouterState} state
 * @param {String} stateName
 * @return {Boolean}
 */
export function stateIncludes(state, stateName) {
  return state.includes[stateName];
}



// WEBPACK FOOTER //
// ./src/js/config/reducers/routerReducer.js